var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Combined Shape"
    ),
    React.createElement(
      "g",
      { id: "search-icon-Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "search-icon-Icon/Browse/24", fill: "#1A1A1A", fillRule: "nonzero" },
        React.createElement("path", { d: "M14.25 0C19.635 0 24 4.365 24 9.75s-4.365 9.75-9.75 9.75a9.707 9.707 0 0 1-4.559-1.13l-4.783 4.786A2.875 2.875 0 0 1 .842 19.09l4.785-4.785A9.707 9.707 0 0 1 4.5 9.75C4.5 4.365 8.865 0 14.25 0zM6.452 15.603l-4.55 4.548a1.375 1.375 0 1 0 1.945 1.944l4.548-4.548a9.807 9.807 0 0 1-1.943-1.944zM14.25 1.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5zm-.062 3.544a4.75 4.75 0 1 1 0 9.5 4.75 4.75 0 0 1 0-9.5zm0 1.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5z", id: "search-icon-Combined-Shape" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/icons/Search.svg